import { SuperAdminConstants } from '../../../_constants';

const initialState = { getAnalyticsMetricListLoading: true, data: '', error: false };

export function getAnalyticsMetricListReducer(state = initialState, action) {
    
    switch (action.type) {
        case SuperAdminConstants.REQUEST_GET_ANALYTICS_METRICS_LIST:
            return {
                getAnalyticsMetricListLoading: true,
                data: '',
                error: false
            };
        case SuperAdminConstants.RECEIVE_GET_ANALYTICS_METRICS_LIST:
            return {
                getAnalyticsMetricListLoading: false,
                data: action.getAnalyticsMetricList,
                error: false
            };
        case SuperAdminConstants.GET_ANALYTICS_METRICS_LIST_ERROR:
            return {
                getAnalyticsMetricListLoading: false,
                data: '',
                error: true
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/SuperAdmin/AssignMetric/getAnalyticsmetricList.reducer.js